import React from 'react'
import {
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { ButtonType } from '../../../../components/GenericButton/styles'

export interface CapLoweringConflict {
  sectionId: string
  sectionTitle: string
  instructorUserId: string
  instructorName: string
  existingQuestionCount: number
}

interface CapLoweringConflictModalProps {
  conflicts: CapLoweringConflict[]
  newQuestionCount: number
  onCancel: () => void
  onConfirm: () => void
  isSubmitting?: boolean
}

const instructorNoun = (count: number): string => (count === 1 ? 'instructor' : 'instructors')

export const CapLoweringConflictModal: React.FC<CapLoweringConflictModalProps> = ({
  conflicts,
  newQuestionCount,
  onCancel,
  onConfirm,
  isSubmitting = false
}) => {
  return (
    <>
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography fontWeight="bold" fontSize="0.875rem">
          Lowering the cap to {newQuestionCount} leaves {conflicts.length}{' '}
          {instructorNoun(conflicts.length)} over the new limit. Their existing questions will
          not be trimmed or changed — only the cap itself is saved.
        </Typography>
      </Alert>

      <TableContainer sx={{ mb: 3 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Section</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Instructor</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Existing Questions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {conflicts.map((conflict) => (
              <TableRow key={`${conflict.sectionId}-${conflict.instructorUserId}`}>
                <TableCell>{conflict.sectionTitle}</TableCell>
                <TableCell>{conflict.instructorName}</TableCell>
                <TableCell>{conflict.existingQuestionCount}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <DefaultModalActions
        destructiveButtonProps={{ onClick: onCancel, disabled: isSubmitting }}
        confirmButtonProps={{
          onClick: onConfirm,
          text: 'Save Anyway',
          buttonType: ButtonType.Primary,
          loading: isSubmitting
        }}
      />
    </>
  )
}
